import { loadD1C } from "./js/D1C/d1c";
import { existDRP } from "./js/D1C/existDRP";
import { watchCookie } from "./js/D1C/observerCookie";
import { saveInboundFisrt, stopRingpool } from "./js/D1C/ringpool";
import { loadWhatsapp } from "./js/D3A/whatsapp";
import { getVisitorId } from "./utils/utils";

/*Codigo de linea 6 a 99 lo recuperamos de : repsol/main/satellite.js*/

if (typeof DFI_client !== "object") {
  var DFI_client = {};
}

DFI_client.getCookie = function (name) {
  let match = globalThis.document.cookie.match(new RegExp(name + "=([^;]+)"));
  if (match) {
    return match[1];
  } else {
    return "";
  }
};

DFI_client.optanon_consent_preferences = false;
DFI_client["optanon_groups_All_true"] = "False";
// DFI_client.clientIdGA4 = DFI.labels.EDeclaratives.clientIdGA4;

/*-----Carga D1C y Whatsapp D3A----*/
/*Cargamos D1C*/

async function loadLibraries() {
  try {



    await loadD1C();
    
    globalThis.idVisitor = await getVisitorId()
    globalThis.leadId = await getVisitorId()

    await loadWhatsapp();

 
    

    
  } catch (error) {
    console.error("Ocurrió un error:", error);
  }
}

if(window.location.hostname=="localhost"){
  setTimeout(function() {
    var cookieValue = "consentId=599b10c5-afd7-42c7-9136-3619bc1eb6ae&datestamp=Fri+Aug+09+2024+09:23:48+GMT+0200+(hora+de+verano+de+Europa+central)&version=202407.1.0&interactionCount=1&isAnonUser=1&isGpcEnabled=0&browserGpcFlag=0&isIABGlobal=false&hosts=&landingPath=NotLandingPage&groups=C0001:0,C0002:0,C0003:0,C0004:0,C0005:0,C0007:0,C0008:0&intType=1";
    var expirationDays = 365; // Duración de la cookie en días
  
    var date = new Date();
    date.setTime(date.getTime() + (expirationDays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + date.toUTCString();
  
    document.cookie = "OptanonConsent=" + encodeURIComponent(cookieValue) + ";" + expires + ";path=/";
  }, 100);
}


saveInboundFisrt()


watchCookie('OptanonConsent', 'groups')

loadLibraries();

/*DCL gracias*/
globalThis.DCL_gracias = (resp) => {
  console.log("Lead Exitoso");
  console.log(resp);
  globalThis.DCL.set.forms();
};

globalThis.DFI_client = DFI_client;
